document.addEventListener('DOMContentLoaded', function() {

	const productCarousel = () => {

		const carousel = document.querySelector('.glide--product');

		if (!carousel || typeof Glide == 'undefined') {
			return;
		}

		const glide = new Glide(carousel, {
			type: 'slider',
			gap: 5,
			perView: 1,
			peek: {
				before: 20,
				after: 20
			},
			bound: true,
			rewind: true,
			throttle: 100,
		});

		glide.mount();

	}

	const productGallery = () => {
		const gallery = document.querySelector('.product__gallery');
		if (!gallery) {
			return;
		}

		const currentImage = document.querySelector('.product__gallery-current');
		const thumbnails = document.querySelectorAll('.product__gallery-thumb');
		let loader;
		const activeClass = 'product__gallery-thumb--current';

		if (!currentImage || !thumbnails) {
			return;
		}

		// Check if the loader hasn't already been created
		if (!document.querySelector('.product__gallery-loader')) {
			loader = document.createElement('div');
			loader.classList.add('product__gallery-loader');
			currentImage.parentElement.appendChild(loader);
		}

		thumbnails.forEach(thumbnail => {
			thumbnail.addEventListener('click', function(evt) {
				// Show the loader
				loader.style.opacity = '1';

				// Hide the main image during loading
				currentImage.style.opacity = '0';

				// Load the new image
				const newSrc = this.dataset.mainSrc;
				const newSrcset = this.dataset.mainSrcset;
				const tempImage = new Image();
				tempImage.src = newSrc;
				tempImage.srcset = newSrcset;

				tempImage.addEventListener('load', () => {
					// Update image attrs
					currentImage.src = newSrc;
					currentImage.srcset = newSrcset;
					currentImage.alt = this.alt;

					// Update active class for thumbnails
					thumbnails.forEach(thumb => thumb.classList.remove(activeClass));
					this.classList.add(activeClass);

					// Hide loader and show image
					loader.style.opacity = '0';
					currentImage.style.opacity = '1';
				});
			});
		});
	}

	const productAccordion = () => {
		const accordion = document.querySelector('.product__accordion');
		if (!accordion) {
			return;
		}

		const items = accordion.querySelectorAll('.product__accordion-item');
		const activeClass = 'product__accordion--active';

		if (!items) {
			return;
		}

		const openAccordion = (item) => {
			const content = item.querySelector('.product__accordion-content');
			item.classList.add(activeClass);
			content.style.maxHeight = content.scrollHeight + 'px';
		};

		const closeAccordion = (item) => {
			const content = item.querySelector('.product__accordion-content');
			item.classList.remove(activeClass);
			content.style.maxHeight = null;
		};

		items.forEach((item) => {
			const button = item.querySelector('.product__accordion-button');
			const content = item.querySelector('.product__accordion-content');

			button.addEventListener('click', () => {
				if (content.style.maxHeight) {
					closeAccordion(item);
				} else {
					items.forEach((item) => closeAccordion(item));
					openAccordion(item);
				}
			}, false);
		});

	}

	productCarousel();
	productGallery();
	productAccordion();

});